import { Product } from '../../types';

export const forkSeriesProducts: Product[] = [
  {
    id: "bt-fork-swt006003",
    name: "Fork Series Terminal - LE103 (SWT006003)",
    slug: "fork-terminal-le103-swt006003",
    category: "Brass Terminal",
    subcategory: "Fork Series",
    description: "LE103 fork terminal for easy connect-disconnect applications. High conductivity brass construction.",
    partNumber: "SWT006003",
    featured: true,
    specifications: {
      "OD Ø": "N/A",
      "ID Ø": "N/A",
      "Cable Size SQ. MM": "N/A",
      "Description": "LE103",
      "Material": "CuZn",
      "Standard Packing": "Spool-8000 Cut-1000",
    },
    images: ["/products/brass-terminals/fork-series/SWT006003.jpg"],
    tags: ["terminal", "fork", "spade", "brass", "le103"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-fork-swt006006",
    name: "Fork Series Terminal - LE106 (SWT006006)",
    slug: "fork-terminal-le106-swt006006",
    category: "Brass Terminal",
    subcategory: "Fork Series",
    description: "LE106 fork terminal with circular base for 2.00-3.00 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT006006",
    specifications: {
      "OD Ø": "12.00 mm",
      "ID Ø": "6.50 mm",
      "Cable Size SQ. MM": "2.00-3.00",
      "Description": "LE106",
      "Material": "CuZn",
      "Standard Packing": "Cut-1000",
    },
    images: ["/products/brass-terminals/fork-series/SWT006006.jpg"],
    tags: ["terminal", "fork", "spade", "brass", "le106"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-fork-swt006007",
    name: "Fork Series Terminal - LE107 U Type (SWT006007)",
    slug: "fork-terminal-le107-u-type-swt006007",
    category: "Brass Terminal",
    subcategory: "Fork Series",
    description: "LE107 U Type fork terminal for 3.50-4.50 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT006007",
    specifications: {
      "OD Ø": "10.20 mm",
      "ID Ø": "5.20 mm",
      "Cable Size SQ. MM": "3.50-4.50",
      "Description": "LE107 U Type",
      "Material": "CuZn",
      "Standard Packing": "Spool-3000 Cut-1000",
    },
    images: ["/products/brass-terminals/fork-series/SWT006007.jpg"],
    tags: ["terminal", "fork", "spade", "brass", "le107"],
    applications: ["Automotive", "Electrical Connections"],
  },
];
